import React from "react";
import PropTypes from "prop-types";
import { optimiseImage } from "src/common/utils/prismic-image";

const Thumbnail = (props) => (
  <img
    className="option-thumbnail"
    src={optimiseImage(props.src)}
    alt={props.alt}
  />
);

Thumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default Thumbnail;
